/* Desde la Pancita — scripts propios (prefijo dp-) */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initReveals() {
    var els = document.querySelectorAll('.dp-reveal:not(.dp-visible)');
    if (!els.length) return;
    if (reduce || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('dp-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('dp-visible'); io.unobserve(e.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  function initParallax() {
    var imgs = document.querySelectorAll('[data-dp-parallax]');
    if (!imgs.length || reduce) return;
    var ticking = false;
    function update() {
      imgs.forEach(function (img) {
        var r = img.parentElement.getBoundingClientRect();
        var k = parseFloat(img.getAttribute('data-dp-parallax')) || 0;
        var off = (r.top + r.height / 2 - window.innerHeight / 2) * -k / 100;
        img.style.transform = 'translate3d(0,' + off.toFixed(1) + 'px,0) scale(1.12)';
      });
      ticking = false;
    }
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
  }

  function initAbrela() {
    document.querySelectorAll('.dp-abrela').forEach(function (sec) {
      var puntos = sec.querySelectorAll('.dp-punto');
      var items = sec.querySelectorAll('.dp-abrela__item');
      function activar(i) {
        puntos.forEach(function (p, j) { p.classList.toggle('is-activo', i === j); });
        items.forEach(function (it, j) { it.classList.toggle('is-activo', i === j); });
      }
      puntos.forEach(function (p, i) {
        p.addEventListener('mouseenter', function () { activar(i); });
        p.addEventListener('click', function () { activar(i); });
      });
      items.forEach(function (it, i) {
        it.addEventListener('mouseenter', function () { activar(i); });
        it.addEventListener('click', function () { activar(i); });
      });
      if (items.length) activar(0);
    });
  }

  function initProducto() {
    document.querySelectorAll('.dp-pdp').forEach(function (sec) {
      // Galería
      var principal = sec.querySelector('.dp-galeria__principal img');
      sec.querySelectorAll('.dp-galeria__mini').forEach(function (b) {
        b.addEventListener('click', function () {
          sec.querySelectorAll('.dp-galeria__mini').forEach(function (x) { x.classList.remove('is-activo'); });
          b.classList.add('is-activo');
          if (!principal) return;
          principal.style.opacity = 0;
          setTimeout(function () {
            principal.src = b.getAttribute('data-src');
            principal.srcset = '';
            principal.style.opacity = 1;
          }, 180);
        });
      });

      // Cantidad
      var qty = sec.querySelector('.dp-cantidad input');
      sec.querySelectorAll('.dp-cantidad button').forEach(function (b) {
        b.addEventListener('click', function () {
          var v = parseInt(qty.value, 10) || 1;
          qty.value = Math.max(1, v + parseInt(b.getAttribute('data-paso'), 10));
        });
      });

      // Variantes
      var data = sec.querySelector('[data-dp-variantes]');
      if (data) {
        var variantes = JSON.parse(data.textContent);
        var inputId = sec.querySelector('input[name="id"]');
        var btn = sec.querySelector('.dp-compra__boton');
        var precio = sec.querySelector('[data-dp-precio]');
        var tachado = sec.querySelector('[data-dp-tachado]');
        var fmt = sec.getAttribute('data-moneda') || '';
        var txtComprar = btn ? btn.getAttribute('data-txt') : '';
        var txtAgotado = btn ? btn.getAttribute('data-agotado') : '';
        function money(c) {
          var n = (c / 100).toFixed(2);
          return fmt.replace(/\{\{\s*amount[^}]*\}\}/, n);
        }
        sec.querySelectorAll('.dp-compra__opcion input').forEach(function (inp) {
          inp.addEventListener('change', function () {
            var sel = [];
            sec.querySelectorAll('.dp-compra__opcion').forEach(function (fs) {
              var c = fs.querySelector('input:checked');
              sel.push(c ? c.value : null);
            });
            var v = variantes.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
            if (!v) {
              if (btn) { btn.disabled = true; btn.querySelector('span').textContent = txtAgotado; }
              return;
            }
            inputId.value = v.id;
            if (precio) precio.textContent = money(v.price);
            if (tachado) {
              tachado.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
            }
            if (btn) {
              btn.disabled = !v.available;
              btn.querySelector('span').textContent = v.available ? txtComprar : txtAgotado;
            }
            var url = new URL(window.location.href);
            url.searchParams.set('variant', v.id);
            window.history.replaceState({}, '', url.toString());
          });
        });
      }

      // Barra fija en móvil
      var barra = sec.querySelector('.dp-barra-movil');
      var form = sec.querySelector('.dp-compra__fila');
      if (barra && form && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          barra.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(form);
      }
    });
  }

  function init() { initReveals(); initParallax(); initAbrela(); initProducto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
